<template>
  <el-dialog
    title="详情"
    width="90%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="handleClose"
    v-if="dialogVisible"
  >
    <div>
      <h3>{{ detail.name | filterName }}的看板</h3>
      <normal-home :agentDetail="detail" :disabled="true" />
      <h3>{{ detail.name | filterName }}的账户分润</h3>
      <account-profit :agentDetail="detail" :disabled="true" />
      <h3>{{ detail.name | filterName }}的下级管理</h3>
      <subordinate-management :agentDetail="detail" :disabled="true" />
      <h3>{{ detail.name | filterName }}的收款方式</h3>
      <payment-list :agentDetail="detail" :disabled="true" />
    </div>
  </el-dialog>
</template>

<script>
import normalHome from "@/views/dashboard/normal-home.vue";
import accountProfit from "@/views/account-profit/index.vue";
import subordinateManagement from "@/views/subordinate-management/list.vue";
import paymentList from "@/views/payment-method/payment-list.vue";
export default {
  name: "AgentDetail",
  props: {
    dialogVisible: {
      type: Boolean,
    },
    detail: {
      type: Object,
    },
  },
  data() {
    return {
      bankList: [],
    };
  },

  created() {},
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
  filters: {
    filterName(name) {
      if (!name) return ''
      if (name.length <= 2) return name.charAt(0) + '*'
      return name.charAt(0) + '*' + name.charAt(name.length - 1)
    }
  },
  components: {
    normalHome,
    accountProfit,
    subordinateManagement,
    paymentList
  },
};
</script>

<style scoped>
h3{
    font-size: 16px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
  text-align: right;
}

.payment-form {
  padding: 0 20px;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  min-height: 40px;
}

.form-label {
  width: 120px;
  text-align: right;
  margin-right: 15px;
  font-weight: bold;
  color: #333;
  font-size: 15px;
  flex-shrink: 0;
}

.form-item ::v-deep .el-input,
.form-item ::v-deep .el-select {
  flex: 1;
  max-width: 300px;
}

/* // 响应式样式 */
@media screen and (max-width: 768px) {
  .payment-form {
    padding: 0 10px;
  }

  .form-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
  }

  .form-label {
    width: auto;
    text-align: left;
    margin-right: 0;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .form-item ::v-deep .el-input,
  .form-item ::v-deep .el-select {
    width: 100%;
    max-width: none;
  }
}

@media screen and (max-width: 480px) {
  .payment-form {
    padding: 0 5px;
  }

  .form-label {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .form-item {
    margin-bottom: 12px;
  }

  .form-item ::v-deep .el-input__inner,
  .form-item ::v-deep .el-select .el-input__inner {
    font-size: 14px;
  }
}
::v-deep .el-dialog__body {
  padding: 0 10px;
}
</style>
